export const isoDateStringToHumanReadable = (input: string): string => {
    const date = new Date(input);
    return date.toLocaleString();
};
